module.exports = __webpack_public_path__ + "static/media/SettingsIconBlack.b0a1224a.svg";